import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { closeModal } from 'ducks/ui/actions';
import PasswordResetConfirmInfo from './PasswordResetConfirmInfo';
import ConfirmDialog from './ConfirmDialog';
import InfoModal from './InfoModal';

class ModalsRoot extends React.PureComponent {
  render() {
    const { handleCloseModal } = this.props;
    return (
      <React.Fragment>
        <PasswordResetConfirmInfo close={handleCloseModal} />
        <ConfirmDialog close={handleCloseModal} />
        <InfoModal close={handleCloseModal} />
      </React.Fragment>
    );
  }
}

ModalsRoot.propTypes = {
  handleCloseModal: PropTypes.func.isRequired
}

const mapDispatch = {
  handleCloseModal: closeModal
};

export default connect(null, mapDispatch)(ModalsRoot);


// WEBPACK FOOTER //
// ./src/components/globalModals/ModalRoot.jsx